import { BackgroundCheckData } from '../entities';

export function isBackgroundCheckConsentGiven(data: Pick<BackgroundCheckData, 'consentBackgroundCheck'>) {
    return data.consentBackgroundCheck;
}
